import { Directive } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-markdown',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [
    { provide: ComponentType, useValue: [ThemeComponent.Markdown, ThemeComponent.MarkdownTable] },
  ],
})
export class FlxMarkdownThemeDirective {}
